import { fromJS } from 'immutable';
import {
  // Figure Data
  GET_FIGURE_DATA,
  GET_FIGURE_DATA_SUCCESS,
  GET_FIGURE_DATA_FAIL,

  // Alerts and Anomalies data
  GET_ALERTS_ANOMALIES_CHART,
  GET_ALERTS_ANOMALIES_CHART_SUCCESS,
  GET_ALERTS_ANOMALIES_CHART_FAIL,

  // Alerts Yield data
  GET_ALERTS_YIELD_CHART,
  GET_ALERTS_YIELD_CHART_SUCCESS,
  GET_ALERTS_YIELD_CHART_FAIL,

  // No Issue and L1 data
  GET_NOISSUE_L1_CHART,
  GET_NOISSUE_L1_CHART_SUCCESS,
  GET_NOISSUE_L1_CHART_FAIL,

  // STR data
  GET_STR_CHART,
  GET_STR_CHART_SUCCESS,
  GET_STR_CHART_FAIL,

  // Alert Status Breakdown
  GET_ALERT_STATUS_CHART,
  GET_ALERT_STATUS_CHART_SUCCESS,
  GET_ALERT_STATUS_CHART_FAIL,

  // Segment List
  GET_SEGMENT_LIST_DATA,
  GET_SEGMENT_LIST_DATA_SUCCESS,
  GET_SEGMENT_LIST_DATA_FAIL,

  // Customer View
  GET_CUSTOMER_DATA,
  GET_CUSTOMER_DATA_SUCCESS,
  GET_CUSTOMER_DATA_FAIL,

  // Cluster View
  GET_CUSTOMER_CLUSTER_CHART,
  GET_CUSTOMER_CLUSTER_CHART_SUCCESS,
  GET_CUSTOMER_CLUSTER_CHART_FAIL
} from '../../actions/tm/dashboard';

const initialState = fromJS({
  figureData: {
    isLoading: false,
    error: null,
    data: null
  },
  chartData: {
    isLoading: false,
    error: null,
    data: null
  },
  customerClusterChartData: {
    isLoading: false,
    error: null,
    data: null
  },
  alertsAnomaliesChartData: {
    isLoading: false,
    error: null,
    data: null
  },
  alertsYieldChartData: {
    isLoading: false,
    error: null,
    data: null
  },
  noIssueL1ChartData: {
    isLoading: false,
    error: null,
    data: null
  },
  strChartData: {
    isLoading: false,
    error: null,
    data: null
  },
  alertStatusChartData: {
    isLoading: false,
    error: null,
    data: null
  },
  customerViewChartData: {
    isLoading: false,
    error: null,
    data: null
  },
  segmentListData: {
    isLoading: false,
    error: null,
    data: null
  },
  segmentData: {
    isLoading: false,
    error: null,
    data: null
  },
  inSegmentData: {
    isLoading: false,
    error: null,
    data: null
  },
  customerData: {
    isLoading: false,
    error: null,
    data: null
  }
});

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case GET_FIGURE_DATA:
      return {
        ...state,
        figureData: { isLoading: true, data: null, error: null }
      };
    case GET_FIGURE_DATA_SUCCESS:
      return {
        ...state,
        figureData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_FIGURE_DATA_FAIL:
      return {
        ...state,
        figureData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_ALERTS_ANOMALIES_CHART:
      return {
        ...state,
        alertsAnomaliesChartData: { isLoading: true, data: [], error: null }
      };
    case GET_ALERTS_ANOMALIES_CHART_SUCCESS:
      return {
        ...state,
        alertsAnomaliesChartData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_ALERTS_ANOMALIES_CHART_FAIL:
      return {
        ...state,
        alertsAnomaliesChartData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_ALERTS_YIELD_CHART:
      return {
        ...state,
        alertsYieldChartData: { isLoading: true, data: [], error: null }
      };
    case GET_ALERTS_YIELD_CHART_SUCCESS:
      return {
        ...state,
        alertsYieldChartData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_ALERTS_YIELD_CHART_FAIL:
      return {
        ...state,
        alertsYieldChartData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_NOISSUE_L1_CHART:
      return {
        ...state,
        noIssueL1ChartData: { isLoading: true, data: [], error: null }
      };
    case GET_NOISSUE_L1_CHART_SUCCESS:
      return {
        ...state,
        noIssueL1ChartData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_NOISSUE_L1_CHART_FAIL:
      return {
        ...state,
        noIssueL1ChartData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_STR_CHART:
      return {
        ...state,
        strChartData: { isLoading: true, data: [], error: null }
      };
    case GET_STR_CHART_SUCCESS:
      return {
        ...state,
        strChartData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_STR_CHART_FAIL:
      return {
        ...state,
        strChartData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_ALERT_STATUS_CHART:
      return {
        ...state,
        alertStatusChartData: { isLoading: true, data: [], error: null }
      };
    case GET_ALERT_STATUS_CHART_SUCCESS:
      return {
        ...state,
        alertStatusChartData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_ALERT_STATUS_CHART_FAIL:
      return {
        ...state,
        alertStatusChartData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_SEGMENT_LIST_DATA:
      return {
        ...state,
        segmentListData: { isLoading: true, data: [], error: null }
      };
    case GET_SEGMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        segmentListData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_SEGMENT_LIST_DATA_FAIL:
      return {
        ...state,
        segmentListData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_CUSTOMER_DATA:
      return {
        ...state,
        customerViewChartData: { isLoading: true, data: [], error: null }
      };
    case GET_CUSTOMER_DATA_SUCCESS:
      return {
        ...state,
        customerViewChartData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_CUSTOMER_DATA_FAIL:
      return {
        ...state,
        customerViewChartData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    case GET_CUSTOMER_CLUSTER_CHART:
      return {
        ...state,
        customerClusterChartData: { isLoading: true, data: [], error: null }
      };
    case GET_CUSTOMER_CLUSTER_CHART_SUCCESS:
      return {
        ...state,
        customerClusterChartData: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_CUSTOMER_CLUSTER_CHART_FAIL:
      return {
        ...state,
        customerClusterChartData: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };

    default:
      return state;
  }
}
